import GeneralDialog from '../../shared/general-dialog';
import { AppLog } from '../../../types';
import AvatarChip from '../../shared/avatar-chip';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
interface LogDetailsDialogProps {
  open: boolean;
  handleClose: () => void;
  selectedLog: AppLog;
}

export default function LogDetailsDialog({
  open,
  handleClose,
  selectedLog,
}: LogDetailsDialogProps) {
  function handlePermission() {
    if (
      selectedLog.permissionNiceName &&
      selectedLog.permissionNiceName !== ''
    ) {
      return selectedLog.permissionNiceName;
    } else if (selectedLog.permission) {
      return selectedLog.permission;
    } else {
      return 'No Permission';
    }
  }

  return (
    <GeneralDialog
      open={open}
      handleClose={handleClose}
      title="App Log Details"
      maxWidth="md"
      dialogContent={
        <>
          <Stack sx={{ pl: 4 }} gap={1}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 4 }}>
                <Stack>
                  <Typography
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    Created Date:
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      maxWidth: 200,
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {new Date(selectedLog.createdDate).toLocaleString()}
                  </Typography>
                </Stack>
              </Grid>
              {selectedLog.permission ? (
                <Grid size={{ xs: 4 }}>
                  <Stack>
                    <Typography
                      sx={{
                        fontWeight: 600,
                      }}
                    >
                      Permission Required:
                    </Typography>
                    <Typography
                      noWrap
                      sx={{
                        maxWidth: 200,
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {handlePermission()}
                    </Typography>
                  </Stack>
                </Grid>
              ) : null}
              <Grid size={{ xs: 4 }}>
                <Stack>
                  <Typography
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    Performing User:
                  </Typography>
                  <Typography
                    sx={{
                      maxWidth: 300,
                      textOverflow: 'ellipsis',
                    }}
                    noWrap
                  >
                    <AvatarChip
                      email={selectedLog.performingUser}
                      type="User"
                    />
                  </Typography>
                </Stack>
              </Grid>
              {selectedLog.target.length > 0 ? (
                <Grid size={{ xs: 4 }}>
                  <Stack>
                    <Typography
                      sx={{
                        fontWeight: 600,
                      }}
                    >
                      Target:
                    </Typography>
                    <Typography
                      noWrap
                      sx={{
                        maxWidth: 400,
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {selectedLog.target}
                    </Typography>
                  </Stack>
                </Grid>
              ) : null}
              <Grid size={{ xs: 4 }}>
                <Stack>
                  <Typography
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    IP Address:
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      maxWidth: 200,
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {selectedLog.ipaddress}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
            {selectedLog.changeLogReason ? (
              <Stack>
                <Typography
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  Change Log Reason:
                </Typography>
                <Typography>{selectedLog.changeLogReason}</Typography>
              </Stack>
            ) : null}
            <Stack>
              <Typography
                sx={{
                  fontWeight: 600,
                }}
              >
                Action:
              </Typography>
              <Typography>{selectedLog.action}</Typography>
            </Stack>
          </Stack>
        </>
      }
      primaryButton={{
        loading: false,
        action: handleClose,
        disabled: false,
        title: 'Close',
      }}
    />
  );
}
